const LLM_API_URL = process.env.REACT_APP_LLM_API_URL || '';

/**
 * Submit a prompt to the LLM service.
 * If REACT_APP_LLM_API_URL is set, sends a real fetch request.
 * Otherwise, returns a mock echo response after a delay.
 *
 * @param {string} prompt - The prompt text
 * @param {object} [options] - Optional parameters (model, temperature, etc.)
 * @returns {Promise<{ response: string, meta: object }>}
 */
export async function submitPrompt(prompt, options = {}) {
  if (LLM_API_URL) {
    const res = await fetch(LLM_API_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ prompt, ...options }),
    });

    if (!res.ok) {
      throw new Error(`LLM service error: ${res.status}`);
    }

    return res.json();
  }

  // Mock mode — echo the prompt after a simulated delay
  await new Promise((resolve) => setTimeout(resolve, 800));
  return {
    response: `[Mock Response]\n\nYou submitted:\n"${prompt}"\n\nThis is a simulated response. Connect a real LLM API by setting REACT_APP_LLM_API_URL.`,
    meta: { mock: true, timestamp: new Date().toISOString() },
  };
}
